import { render, staticRenderFns } from "./clases.vue?vue&type=template&id=cbd94cce"
import script from "./clases.vue?vue&type=script&lang=js"
export * from "./clases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports